import { IAdjustment, IAdjustmentData, IAdjustmentItem, IAdjustmentParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const adjustmentsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_adjustments: builder.query<ITableRes<IAdjustmentItem>, IAdjustmentParams>({
      query: (params) => ({
        url: '/adjustments/',
        params,
      }),
      providesTags: ['adjustments'],
    }),
    GET_adjustmentById: builder.query<IAdjustment, string>({
      query: (id) => {
        return {
          url: `/adjustments/${id}/`,
        }
      },
      providesTags: ['adjustments'],
    }),
    POST_adjustment: builder.mutation<IAdjustment, IAdjustmentData>({
      query: (body) => ({
        url: `/adjustments/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['adjustments'],
    }),
    PUT_adjustment: builder.mutation<IAdjustment, { id: string; body: IAdjustmentData }>({
      query: ({ id, body }) => ({
        url: `/adjustments/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['adjustments', 'rti-intervention'],
    }),
    DELETE_adjustment: builder.mutation<IAdjustment, string>({
      query: (id) => ({
        url: `/adjustments/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['adjustments'],
    }),
  })
})

export const {
  useGET_adjustmentsQuery,
  useGET_adjustmentByIdQuery,
  usePOST_adjustmentMutation,
  usePUT_adjustmentMutation,
  useDELETE_adjustmentMutation,
} = adjustmentsAPI
